module.exports = __webpack_public_path__ + "static/item--sofa-1@3x.4aac3da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--sofa-1@3x.png
// module id = 663
// module chunks = 126511778744290